import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { LoadingComponent } from './loading/loading.component';
import { ErrorpopupComponent } from './popups/errorpopup/errorpopup.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ClickAndDoubleClickDirective } from './directives/click-and-double-click.directive';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SupportPopupModule } from '../components/support-popup/support-popup.module';

@NgModule({
  declarations: [LoadingComponent, ErrorpopupComponent, ClickAndDoubleClickDirective ],
  imports: [
    CommonModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpTranslateLoader,
        deps: [HttpClient]
      }
    }),
    BrowserAnimationsModule,
    SupportPopupModule  
  ],
  providers: [],
  // providers: [LoaderService, HttpInterceptProviders],
  exports: [LoadingComponent, ErrorpopupComponent, ClickAndDoubleClickDirective,SupportPopupModule ],
})
export class SharedModule { }

export function httpTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http);
}